import React from "react";
import bannerImg from "../../../../Assets/Images/Copilot_Cloud 1 - Edited.png";
import { motion } from "framer-motion";
import "../AllBanner/DatabaseBanner.css";
import "../AllBanner/technologiesBanner.css";
import { Link } from "react-router-dom";

const CloudBanner = () => {
  return (
    <div
      className="tech-web-banner"
      style={{
        background: "linear-gradient(90deg,  #0b4f5d)",
        color: "white",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <style>
        {`
          /* Default (desktop) */
          .cloud-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 40px;
            padding: 0; /* remove container padding */
          }
 
          .cloud-img {
            flex: 1;
            text-align: right;
          }
 
          .cloud-img img {
            display: block;
            width: 75%;
            height: auto;
            margin: 0;
            padding: 0;
            mix-blend-mode: lighten;
          }

          @media (max-width:1024px){
          .cloud-img img {
            width: 100%;
          }
          }
 
          /* Mobile (small) */
          @media (max-width: 992px) {
          .cloud-container {
              padding: 20px 20px 0px 20px;
              flex-direction: column;
              margin: 0px;
            }
                .cloud-img img {
         
            width: 100%;
          
          }
            .cloud-text h2 {
              font-size: 2.8rem;
            }
 
            .cloud-text p {
              font-size: 1.4rem;
            }
 
            .cloud-button {
              font-size: 0.9rem;
              padding: 8px 20px;
              margin: 0 auto;
            }
          }
        @media (min-width: 1600px) {
          .cloud-img{
          display: flex;
          justify-content: center;
          }
          .cloud-img img {
            width: 60%;
          }
        }
        `}
      </style>

      {/* ✅ Banner Container */}
      <div
        className="cloud-container  container-fluid"
        style={{
          padding: "0",
          gap: "80px",
          width: "90%",
          margin: "0 auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-center cloud-text"
          style={{
            flex: "1",
            maxWidth: "500px",
            paddingTop: "40px",
            paddingBottom: "20px",
          }}
        >
          <h2 className="cloud-heading-cloud fw-semibold text-center text-md-start mb-3">
            When Cloud Decisions Start Affecting The Business
          </h2>

          <p className="mb-3 database-text small mb-4 text-center text-md-start">
            Most companies migrate to the cloud to ship faster. The real
            consequences manifest months later in soaring costs, unclear
            ownership, brittle deployments, and systems that no one fully
            understands. At Quad Theory Ltd, we collaborate with teams when
            cloud decisions start to impact delivery speed, reliability, and
            budget.
          </p>

          <Link className="mx-auto mx-md-0 " to="/contact-us">
            <motion.button
              type="button"
              className="data-button px-5 py-3 rounded-pill align-self-start mx-auto mx-md-0 cloud-button"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                zIndex: 5,
                fontWeight: "500",
                fontSize: "1.4rem",
              }}
            >
              Discuss Your Cloud Setup
            </motion.button>
          </Link>
        </div>

        {/* ✅ Right Image Section */}
        <div className="cloud-img">
          <img src={bannerImg} alt="Banner" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};

export default CloudBanner;
